import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import Vidle from "v-idle";
import { xLocalStorage } from "@/core/services/xLocalStorage.service";

Vue.config.productionTip = false;
Vue.use(Vidle);

// Global 3rd party plugins
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/loadScript";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/inline-svg";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";
import "leaflet/dist/leaflet.css";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import "vazir-font/dist/font-face.css";
import "vazir-font/dist/Farsi-Digits/font-face-FD.css";

fetch(process.env.BASE_URL + `infrastructure/appSettings.json`).then(
  async response => {
    // Merge settings based on environment
    let settings = await response.json();

    if (process.env.NODE_ENV !== "production") {
      const otherEnvironmentResponse = await fetch(
        process.env.BASE_URL +
          `infrastructure/appSettings.${process.env.NODE_ENV}.json`
      );

      const otherEnvironmentSettings = await otherEnvironmentResponse.json();

      settings = { ...settings, ...otherEnvironmentSettings };
    }

    // Check to clear cache
    const APP_VERSION = "version";
    const storedAppVersion = xLocalStorage.get(APP_VERSION);
    if (!storedAppVersion || storedAppVersion !== settings.version) {
      xLocalStorage.clear();
      xLocalStorage.set(APP_VERSION, settings.version);
    }

    Vue.prototype.$xSettings = settings;

    // API service init
    ApiService.init();

    router.beforeEach((to, from, next) => {
      // Ensure we checked auth before each page load.
      Promise.all([]).then(next);

      // reset config to initial state
      store.dispatch(RESET_LAYOUT_CONFIG);

      // Scroll page to top on every route change
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    });

    router.afterEach((to, from) => {
      if (to.meta.error) {
        if (to.redirectedFrom) {
          window.history.replaceState({}, null, to.redirectedFrom);
        } else {
          window.history.replaceState({}, null, from.path);
        }
      }
    });

    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
);
